import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { analytics } from '@/lib/services/analytics'

export function PageviewTracker() {
  const location = useLocation()

  useEffect(() => {
    analytics.capturePageview(location.pathname + location.search)
  }, [location.pathname, location.search])

  return null
}
